export default {
  kefu: {
    accessId: '5a2dc1f0-0ec0-11eb-9e22-81117e5e10cc',
  },
}
